const ebookWhitepaperButtonContainer = document.querySelector('[data-behaviour="ebook-whitepaper-load-more-show"]');
const ebookWhitepaperButton = document.querySelector('[data-behaviour="ebook-whitepaper-load-more"]');

if (ebookWhitepaperButtonContainer) {
	ebookWhitepaperButtonContainer.style.display = "flex";
}

if (ebookWhitepaperButton) {

	ebookWhitepaperButton.addEventListener('click', () => {
		// Elements
		const section = ebookWhitepaperButton.closest('[data-ref="ebook-whitepaper-list"]');
		const sectionInner = section.querySelector('[data-ref="ebook-whitepaper-inner"]');
		let activeNav = section.querySelector('[data-active="1"]');
		// Text
		const loadingSpan = '<span>.</span><span>.</span><span>.</span>'
		const loadingText = 'Loading' + loadingSpan;
		const defaultButtonText = 'Load more';
		//Disable Button
		ebookWhitepaperButton.disabled = true;
		ebookWhitepaperButton.innerHTML = loadingText;
		//Form Vars
		let activeKey = activeNav.dataset?.key;
		let paged = ebookWhitepaperButton.dataset?.paged;

		fetchEbookWhitepapers(activeKey, paged)
			.then(response => {
				if (response.status === 'success' && response.html) {
					sectionInner.innerHTML += response.html;

					if (response.data &&
						!response.data.pagination
					) {
						ebookWhitepaperButton.classList.add('ebook-whitepaper-list__button--hidden');
					} else {
						ebookWhitepaperButton.classList.remove('ebook-whitepaper-list__button--hidden');
					}

				} else {
					console.log('Error during fetch response');
				}

				ebookWhitepaperButton.disabled = false;
				ebookWhitepaperButton.innerHTML = defaultButtonText;
			})
			.catch(error => {
				console.log('Error during fetch: ' + error);
			});
	});
}

const EbookWhitepapersNav = document.querySelectorAll('[data-behaviour="ebook-whitepaper-two-filter"]');

if (EbookWhitepapersNav.length) {
	// Elements
	const section = EbookWhitepapersNav[0].closest('[data-ref="ebook-whitepaper-list"]');
	const sectionInner = section.querySelector('[data-ref="ebook-whitepaper-inner"]');

	EbookWhitepapersNav.forEach(el => {
		el.addEventListener('click', () => {
			//disabled buttons
			EbookWhitepapersNav.forEach(button => {
				button.disabled = true;
			});

			//Form Els
			const activeKey = el.dataset?.key;
			const paged = 1; // will always be 1 on first click
			const activeNav = section.querySelector('[data-active="1"]');

			fetchEbookWhitepapers(activeKey, paged)
				.then(response => {
					if (response.status === 'success' && response.html) {
						sectionInner.innerHTML = response.html;

						if (response.data &&
							!response.data.pagination
						) {
							ebookWhitepaperButton.classList.add('ebook-whitepaper-list__button--hidden');
						} else {
							ebookWhitepaperButton.classList.remove('ebook-whitepaper-list__button--hidden');
						}

						activeNav.dataset.active = 0;
						activeNav.classList.remove('button--active');

						el.dataset.active = 1;
						el.classList.add('button--active');

					} else {
						console.log('Error during fetch response');
					}

					//enable buttons
					EbookWhitepapersNav.forEach(button => {
						button.disabled = false;
					});
				})
				.catch(error => {
					console.log('Error during fetch: ' + error);
				});
		});
	});

	const selectFilter = document.querySelector('[data-select="ebook-whitpaper-filter"]');
	if (selectFilter) {
		selectFilter.addEventListener('change', (e) => {
			let activeKey = e.target.value; //category id
			const paged = 1; // will always be 1 on first click

			fetchEbookWhitepapers(activeKey, paged)
				.then(response => {
					if (response.status === 'success' && response.html) {
						sectionInner.innerHTML = response.html;

						if (response.data &&
							!response.data.pagination
						) {
							ebookWhitepaperButton.classList.add('blog-post-list__button--hidden');
						} else {
							ebookWhitepaperButton.classList.remove('blog-post-list__button--hidden');
						}
						let activeNav = section.querySelector('[data-active="1"]');
						activeNav.dataset.active = 0;
						activeNav.classList.remove('button--active');
						//button on nav
						let getFilterNav =  section.querySelector(`[data-key="${activeKey}"]`)//just in case resize
						getFilterNav.dataset.active = 1;
						getFilterNav.classList.add('button--active');

					} else {
						console.log('Error during fetch response');
					}
				})
				.catch(error => {
					console.log('Error during fetch: ' + error);
				});

		});
	}
}

/**
 * fetchEbookWhitepapers
 * @param {Number} activeKey TermId
 * @param {Number} paged Default 1
 * @returns JSON response (EbookWhitepapers)
 */
const fetchEbookWhitepapers = async ( activeKey, paged = 1 ) => {
	// FORM
	const formData = new FormData();
	formData.set('security', wp_ajax.security);
	formData.set('activeKey', activeKey);
	formData.set('paged', paged);

	const response = await fetch(`${wp_ajax.ajax_url}?action=ebook_whitepaper_load_more`, {
		method: 'POST',
		body: formData
	})

	if (!response.ok) {
		const message = `An error has occured: ${response.status}`;
		throw new Error(message);
	}

	const EbookWhitepapers = await response.json();

  	return EbookWhitepapers;
}
